import apiClient from './client';

export const IcdRuleAxiosInstance = apiClient;